import React from "react";
import backImg from "./mainBackground2.jpg";
import ArrowDropDownCircleIcon from "@material-ui/icons/ArrowDropDownCircle";
import GitHubIcon from "@material-ui/icons/GitHub";
import LinkedInIcon from "@material-ui/icons/LinkedIn";
import EmailIcon from "@material-ui/icons/Email";
import Tooltip from "@material-ui/core/Tooltip";
import {
  homeActive,
  aboutActive,
  resumeActive,
  projectActive,
  contactActive,
} from "../jsFunctions";
function Home() {
  return (
    <div
      className="homeMaindiv"
      style={{
        backgroundImage: `url(${backImg})`,
      }}
    >
      <div className="innerHome">
        <Nav />
        <div className="homeContent">
          <center>
            <h1 className="display-2">I'm Shivaji Kumar.</h1>
            <br />
            <h4>
              I'm india based MERN Stack and React Native Developer,
              <br /> and currently studing Bechelor's In <br />
              Computer Science. <br />
            </h4>
            <hr className=" w-50 mx-auto bg-white" />
            <div className="socialMedia">
              <div className="row">
                <a href="https://github.com/SHIVAJIKUMAR007" target="shivaji">
                  <Tooltip title="GitHub" className="socialMediaLinks">
                    <GitHubIcon fontSize="large" />
                  </Tooltip>
                </a>

                <a
                  href="https://www.linkedin.com/in/shivaji-kumar-193a61192/"
                  target="shivaji"
                >
                  <Tooltip title="Linkedin" className="socialMediaLinks">
                    <LinkedInIcon fontSize="large" />
                  </Tooltip>
                </a>

                <a
                  href="mailto:official.shivaji007@gmail.com"
                  target="shivaji kumar"
                >
                  <Tooltip
                    title="Click To Mail Me"
                    className="socialMediaLinks"
                  >
                    <EmailIcon fontSize="large" />
                  </Tooltip>
                </a>
              </div>
            </div>
            <br />
            <br />
            <br />
          </center>
        </div>
        <div>
          <Tooltip
            title="Go Down"
            className="socialMediaLinks"
            onClick={aboutActive}
          >
            <ArrowDropDownCircleIcon fontSize="large" />
          </Tooltip>
        </div>
      </div>
    </div>
  );
}

const Nav = () => {
  return (
    <nav className="navBar" id="nav">
      <ul className="nav justify-content-center">
        <li className="nav-item">
          <p className="nav-link active" id="home" onClick={homeActive}>
            Home
          </p>
        </li>
        <li className="nav-item">
          <p className="nav-link " id="about" onClick={aboutActive}>
            About
          </p>
        </li>
        <li className="nav-item">
          <p className="nav-link " id="resume" onClick={resumeActive}>
            Resume
          </p>
        </li>
        <li className="nav-item">
          <p className="nav-link" id="project" onClick={projectActive}>
            Projects
          </p>
        </li>
        <li className="nav-item">
          <p className="nav-link" id="contact" onClick={contactActive}>
            Contact Me
          </p>
        </li>
      </ul>
    </nav>
  );
};
export default Home;
